/* PawRegal first_sale layer (2026-11-01). Loaded on every page (layout/theme.liquid). Truthful by construction:
   - Flash offer: a REAL per-shopper single-use Shopify code with a real expiry, started by the pipeline when previews
     first appear (POST /api/offer/start, once per visitor per 24 h). The countdown reads the server's ends_at; it is
     never reset or looped. At 0 the code is expired in Shopify and the UI says "Offer ended".
   - Live counter: GET /api/social-proof returns real counts (synthetic/test/bot traffic excluded) or null; null = hidden.
   - Funnel events (page_viewed, preview_viewed, style_picked, add_to_cart, cart_viewed, checkout_started) -> POST /api/events with the
     widget session id + first-touch utm_content (ad name). AddToCart / InitiateCheckout also go to the Meta pixel with
     the same event_id the pipeline sends to CAPI (dedup).
   Public API: window.PRFS = { track, flashActive, applyFlash, flash } */
(function () {
  'use strict';
  var C = window.PR_FS || {};
  var API = String(C.api || '').replace(/\/$/, '');
  if (!API || window.PRFS) return;

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function sid() { try { var v = localStorage.getItem('pp_sid'); if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('pp_sid', v); } return v; } catch (e) { return 'anon'; } }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function uuid() { try { return crypto.randomUUID(); } catch (e) { return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2); } }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  // ---------- first-touch UTM (ad name in utm_content), 30 days ----------
  (function () {
    var q = new URLSearchParams(location.search);
    if (q.get('utm_source') || q.get('utm_content') || q.get('utm_campaign')) lsSet('pr_utm', { s: q.get('utm_source'), c: q.get('utm_campaign'), n: q.get('utm_content'), f: !!q.get('fbclid'), t: Date.now() });
    // Meta click without our utm tags (e.g. a manual boost): still attribute the session to Meta.
    else if (q.get('fbclid') && !lsGet('pr_utm')) lsSet('pr_utm', { s: 'facebook', c: null, n: null, f: true, t: Date.now() });
  })();
  function utm() { var u = lsGet('pr_utm'); return u && Date.now() - u.t < 30 * 864e5 ? u : {}; }

  // ---------- Meta pixel (only AddToCart / InitiateCheckout, never PageView; Shopify's channel handles the rest) ----------
  var pixelId = null;
  function fbqLoad(id) {
    if (!id || window.fbq) return;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('set', 'autoConfig', false, id);
    window.fbq('init', id);
  }
  var PIXEL_NAME = { add_to_cart: 'AddToCart', checkout_started: 'InitiateCheckout' };
  // tracking audit 2026-11-01: Shopify's Meta channel already fires these (browser + server); ours only when /api/launch says 'own'.
  var ownCart = false;

  // ---------- funnel events ----------
  function track(event, d) {
    d = d || {};
    var u = utm(), eid = d.event_id || (PIXEL_NAME[event] ? uuid() : undefined);
    var body = { event: event, session_id: sid(), upload_id: d.upload_id || undefined, preview_id: d.preview_id || undefined, utm_source: u.s, utm_campaign: u.c, utm_content: u.n, fbclid: u.f === undefined ? undefined : !!u.f, value: d.value, event_id: eid, page: location.pathname, url: location.href.split('?')[0], fbp: cookie('_fbp'), fbc: cookie('_fbc') };
    var s = JSON.stringify(body);
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(API + '/api/events', new Blob([s], { type: 'text/plain' })))) throw 0; }
    catch (e) { try { fetch(API + '/api/events', { method: 'POST', body: s, headers: { 'content-type': 'text/plain' }, keepalive: true, mode: 'cors' }); } catch (e2) {} }
    if (ownCart && PIXEL_NAME[event] && window.fbq) { try { window.fbq('track', PIXEL_NAME[event], { value: Number(d.value || 0), currency: 'USD', content_type: 'product' }, { eventID: eid }); } catch (e) {} }
    return eid;
  }

  // ---------- flash offer ----------
  var F = lsGet('pr_flash'); // { code, ends (ms), off (server - client ms), status, applied, sid }
  if (F && F.sid && F.sid !== sid()) F = null;
  function now() { return Date.now() + (F && F.off || 0); }
  function flashActive() { return !!(F && F.status === 'active' && F.code && F.ends > now()); }
  function setF(r) {
    if (!r || r.status === 'off') { if (!F || F.status !== 'ended') { F = null; lsSet('pr_flash', null); } render(); return; }
    var prevApplied = F && F.code && F.code === r.code && F.applied;
    F = { code: r.code || null, ends: Date.parse(r.ends_at), off: Date.parse(r.server_now) - Date.now(), status: r.status, applied: !!prevApplied, amount: r.amount_off || (F && F.amount) || 7, sid: sid() };
    lsSet('pr_flash', F); render();
  }
  function startFlash(uploadId) {
    if (F && F.status === 'ended') { render(); return; }
    if (flashActive()) { render(); return; }
    fetch(API + '/api/offer/start', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ session_id: sid(), upload_id: uploadId || undefined }) })
      .then(function (r) { return r.json(); }).then(setF).catch(function () {});
  }
  function syncFlash() {
    // Server state wins (same device, cleared storage or a second tab keeps the SAME offer and the same end time).
    // A visitor with no local offer only adopts an ACTIVE one; we never show "Offer ended" to someone who never saw it.
    fetch(API + '/api/offer/status?session_id=' + encodeURIComponent(sid())).then(function (r) { return r.json(); })
      .then(function (r) { if (r.status === 'active' || (F && r.status === 'ended')) setF(r); }).catch(function () {});
  }
  /** Puts the code on the cart (Shopify validates it; after ends_at Shopify rejects it). */
  function applyFlash() {
    if (!flashActive()) return Promise.resolve(false);
    var code = F.code;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { var ok = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code; }); if (!ok) throw 0; F.applied = true; lsSet('pr_flash', F); return true; })
      .catch(function () { return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).then(function () { F.applied = true; lsSet('pr_flash', F); return true; }).catch(function () { return false; }); });
  }
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  var onCart = /^\/cart\/?$/.test(location.pathname);
  function render() {
    var els = document.querySelectorAll('[data-pr-flash]');
    var active = flashActive();
    var left = F ? F.ends - now() : 0;
    els.forEach(function (el) {
      if (!F) { el.hidden = true; return; }
      el.hidden = false;
      el.classList.toggle('is-ended', !active);
      var amt = '$' + Number(F.amount || 7).toFixed(0);
      if (active) {
        var t = '<span class="pr-flash__t" aria-hidden="true">' + mmss(left) + '</span>';
        var inner = el.getAttribute('data-pr-flash') === 'pdp' || el.closest('#pr-upload')
          ? (window.__prMulti && Number(window.__prTarget || 0) >= 3
            // parity 2026-11-01: Shopify applies one deal per order; the N-ornament deal beats the $7 code, so say so.
            ? '' // owner 2026-11-01: the multi-ornament deal already wins; no extra text
            : '🎁 <b>Free digital file</b> · ' + t)
          : '🎁 <b>Free digital file</b> · ' + t + (F.applied ? ' · applied' : '');
        if (el.getAttribute('data-sr') !== '1') { el.setAttribute('role', 'timer'); el.setAttribute('aria-label', 'Free digital file offer, ' + Math.ceil(left / 60000) + ' minutes left'); }
        el.innerHTML = inner; el.hidden = !inner;
      } else {
        el.innerHTML = ''; el.hidden = true;
      }
    });
    // floating checkout bubble (assets/pr-cro.js)
    var fab = document.getElementById('pr-fab');
    if (fab) {
      var b = fab.querySelector('.pr-fab__flash');
      if (active) { if (!b) { b = document.createElement('span'); b.className = 'pr-fab__flash'; fab.appendChild(b); } b.textContent = 'Free file ' + mmss(left); }
      else if (b) b.remove();
    }
    if (F && F.status === 'active' && !active) { F.status = 'ended'; lsSet('pr_flash', F); document.dispatchEvent(new CustomEvent('pr:flash', { detail: { active: false } })); }
  }
  setInterval(render, 1000);

  // ---------- live counter (real numbers or nothing) ----------
  function social() {
    var el = document.querySelector('[data-pr-social]'); if (!el) return;
    fetch(API + '/api/social-proof').then(function (r) { return r.json(); }).then(function (s) {
      var bits = [];
      if (s && s.portraits_recent) bits.push(s.portraits_recent + ' portraits made in the last ' + s.window_min + ' minutes');
      if (s && s.added_to_cart_today) bits.push(s.added_to_cart_today + ' added to cart today');
      if (!bits.length) { el.hidden = true; return; }
      el.textContent = bits.join(' · '); el.hidden = false;
    }).catch(function () {});
  }

  // ---------- cart value for InitiateCheckout ----------
  var cartTotal = null;
  function refreshCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price; return c; }).catch(function () { return null; }); }
  var ic = false;
  function checkoutStarted() { if (ic) return; ic = true; track('checkout_started', { value: cartTotal != null ? cartTotal / 100 : undefined }); }
  document.addEventListener('submit', function (ev) { var s = ev.submitter; if (s && s.name === 'checkout') checkoutStarted(); }, true);
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href*="/checkout"], #pr-fab, button[name="checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (a) checkoutStarted();
  }, true);

  // ---------- widget events ----------
  window.addEventListener('portrait:previews', function (e) {
    var d = (e && e.detail) || {};
    if (!d.restored) track('preview_viewed', { upload_id: d.upload_id });
    startFlash(d.upload_id);
  });
  window.addEventListener('portrait:selected', function (e) {
    var d = (e && e.detail) || {};
    track('style_picked', { upload_id: d.upload_id || (d.properties && d.properties._upload_id), preview_id: d.preview && d.preview.id });
  });

  window.PRFS = { track: track, flashActive: flashActive, applyFlash: applyFlash, flash: function () { return F; }, refreshCart: refreshCart, render: render, sid: sid };

  // ---------- boot ----------
  fetch(API + '/api/launch').then(function (r) { return r.json(); }).then(function (c) { pixelId = c.pixel_id; ownCart = c.meta_cart_events === 'own'; fbqLoad(pixelId); /* widget PreviewGenerated needs fbq */ }).catch(function () {});
  track('page_viewed'); // tracking audit 2026-11-01: page_viewed was in policy.catalog.funnel_events but never sent
  syncFlash(); render(); social();
  refreshCart().then(function (c) {
    var hasCode = c && (c.discount_codes || []).some(function (d) { return F && String(d.code).toUpperCase() === F.code; });
    if (F && F.applied !== !!hasCode && c && c.item_count) { F.applied = !!hasCode; lsSet('pr_flash', F); render(); }
    if (!onCart && flashActive() && c && c.item_count && !hasCode) applyFlash().then(function (ok) { render(); if (ok && window.PRCart && window.PRCart.refresh) window.PRCart.refresh(); });
    if (onCart) {
      track('cart_viewed', { value: c ? c.total_price / 100 : undefined });
      // Offer still running and the code not on the cart yet (e.g. added from the drawer): apply it once.
      if (flashActive() && c && !hasCode) applyFlash().then(function (ok) { var k = 'pr_flash_rl_' + F.code; try { if (ok && !sessionStorage.getItem(k)) { sessionStorage.setItem(k, '1'); location.reload(); } } catch (e) {} });
    }
  });
})();
